// Cart tick box JS
function clickTickbox() {
  var checkBox = document.getElementsByClassName("checkbox-checkout");
  var prevent_click = document.getElementsByClassName("prevent-click");

  if (checkBox[0].checked == true){
    prevent_click[0].style.display = "none";
  } else {
    prevent_click[0].style.display = "block";
  }
}

function checkoutError() {
  var checkoutError = document.getElementsByClassName("checkbox-checkout-error");
  checkoutError[0].style.opacity = 1;
}
// End cart tick box JS